import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useGiveawayState } from "@/lib/useGiveaway";

const KEY = "vg_teaser_hidden";

export default function GiveawayTeaserModal() {
  const { data } = useGiveawayState();
  const [open, setOpen] = useState(false);
  const [dontShow, setDontShow] = useState(false);
  const phase = data?.phase;

  useEffect(() => {
    if (phase === "teaser" && localStorage.getItem(KEY) !== "1" && sessionStorage.getItem(KEY) !== "1") {
      const t = setTimeout(() => {
        sessionStorage.setItem(KEY, "1");
        setOpen(true);
      }, 1200);
      return () => clearTimeout(t);
    }
  }, [phase]);

  if (!open) return null;
  const close = () => {
    if (dontShow) localStorage.setItem(KEY, "1");
    setOpen(false);
  };
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" data-testid="giveaway-teaser-modal">
      <div className="relative w-full max-w-lg overflow-hidden rounded-2xl bg-[#070d1c] border border-launch/40 shadow-2xl">
        <button onClick={close} className="absolute top-3 right-3 z-10 text-white/70 hover:text-white bg-black/40 rounded-full p-1.5" aria-label="Close" data-testid="giveaway-teaser-close">
          <X className="h-5 w-5" />
        </button>
        <img src="/giveaway/teaser.jpg" alt="Aquila Air & Heating Veteran HVAC Giveaway" className="w-full h-40 object-cover" />
        <div className="p-6 sm:p-8 text-center">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-launch">🇺🇸 Something Big Is Coming</p>
          <h2 className="mt-2 text-2xl sm:text-3xl font-extrabold text-white leading-tight">This Veterans Day</h2>
          <p className="mt-3 text-slate-300 text-sm leading-relaxed">
            We're giving away a <strong className="text-white">Brand-New HVAC System + Professional Installation</strong> to a veteran in need. We're looking for a veteran whose story deserves to be heard.
          </p>
          <div className="mt-4 space-y-1 text-sm">
            <p className="text-white font-semibold">🗓️ Nominations &amp; Public Voting Open October 1, 2026</p>
            <p className="text-launch font-bold">🏆 Winner Announced Veterans Day — November 11, 2026</p>
          </div>
          <Link to="/veteran-hvac-giveaway" onClick={close} data-testid="giveaway-teaser-learn-more"
            className="mt-6 inline-flex items-center justify-center bg-launch hover:bg-launch-dark text-white font-bold py-3 px-8 rounded-md w-full transition-colors">
            Learn More
          </Link>
          <label className="mt-4 flex items-center justify-center gap-2 text-xs text-slate-400 cursor-pointer">
            <input type="checkbox" checked={dontShow} onChange={(e) => setDontShow(e.target.checked)} data-testid="giveaway-teaser-dontshow" />
            Don't show this again
          </label>
          <p className="mt-2 text-[11px] text-slate-500">Aquila Air &amp; Heating — Comfort Ready for Liftoff</p>
        </div>
      </div>
    </div>
  );
}
